import { render, staticRenderFns } from "./ParagraphWithFold.vue?vue&type=template&id=4613ecbb&scoped=true&"
import script from "./ParagraphWithFold.vue?vue&type=script&lang=ts&"
export * from "./ParagraphWithFold.vue?vue&type=script&lang=ts&"
import style0 from "./ParagraphWithFold.vue?vue&type=style&index=0&id=4613ecbb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613ecbb",
  null
  
)

export default component.exports